<main>
    <div class="loginWraper">
        <form class="form" [formGroup]="passwordForm">            
            <div>
                <div class="form-group mx-2 pos_rel mb-3  position-relative">
                    <input [type]="oldPasswordFlag ? 'text' : 'password'" placeholder="વર્તમાન પાસવર્ડ "
                        class="form-control lgn_input" formControlName="oldPassword" required>
                    <span class="passEye" (click)="oldPassword()">
                        <i style="cursor: pointer;" class="ti ti-eye" *ngIf="oldPasswordFlag"></i>
                        <i style="cursor: pointer;" class="ti ti-eye-off" *ngIf="!oldPasswordFlag"></i>
                    </span>

                    <div *ngIf="passwordSubmitted && f.oldPassword.errors" class="error-message">
                        <small *ngIf="f.oldPassword.errors?.required" class="text-danger">વર્તમાન પાસવર્ડ જરૂરી
                            છે.</small>
                    </div>
                </div>
                <div class="form-group mx-2 pos_rel mb-3  position-relative">
                    <input [type]="showPassword ? 'text' : 'password'" placeholder="પાસવર્ડ "
                        class="form-control lgn_input" formControlName="password" required>
                    <span class="passEye" (click)="password()">
                        <i style="cursor: pointer;" class="ti ti-eye" *ngIf="showPassword"></i>
                        <i style="cursor: pointer;" class="ti ti-eye-off" *ngIf="!showPassword"></i>
                    </span>
                    <div *ngIf="passwordSubmitted && f.password.errors" class="error-message">
                        <small *ngIf="f.password.errors?.required" class="text-danger">પાસવર્ડ જરૂરી છે.</small>
                    </div>
                </div>
                <div class="form-group mx-2 pos_rel mb-3  position-relative">
                    <input [type]="confirmPassword ? 'text' : 'password'" placeholder="કન્ફર્મ પાસવર્ડ"
                        class="form-control lgn_input" formControlName="cpassword" required="">
                    <span class="passEye" (click)="confirmPwd()">
                        <i style="cursor: pointer;" class="ti ti-eye" *ngIf="confirmPassword"></i>
                        <i style="cursor: pointer;" class="ti ti-eye-off" *ngIf="!confirmPassword"></i>
                    </span>
                    <div *ngIf="f.cpassword.errors && passwordSubmitted" class="error-message">
                        <small *ngIf="f.cpassword.errors?.required" class="text-danger">પુષ્ટિ પાસવર્ડ જરૂરી છે.</small>
                        <small *ngIf="f.cpassword.errors.mustMatch" class="text-danger">
                            બંને પાસવર્ડ મેળ ખાતા નથી
                        </small>
                    </div>
                </div>
            </div>
            <button class="btn-common" type="submit" (click)="changePassword()">પાસવર્ડ રીસેટ કરો</button>
        </form>
    </div>
</main>